import apiClient from '../utils/apiClient';
import {
  CREATE_DISCOUNT_REQUEST,
  CREATE_DISCOUNT_SUCCESS,
  CREATE_DISCOUNT_FAIL,
  LIST_DISCOUNTS_REQUEST,
  LIST_DISCOUNTS_SUCCESS,
  LIST_DISCOUNTS_FAIL,
  DISCOUNT_DETAILS_REQUEST,
  DISCOUNT_DETAILS_SUCCESS,
  DISCOUNT_DETAILS_FAIL,
  UPDATE_DISCOUNT_REQUEST,
  UPDATE_DISCOUNT_SUCCESS,
  UPDATE_DISCOUNT_FAIL,
  DELETE_DISCOUNT_REQUEST,
  DELETE_DISCOUNT_SUCCESS,
  DELETE_DISCOUNT_FAIL,
} from '../constants/discountConstants';

export const createDiscount = (payload) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_DISCOUNT_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' } };
  const { data } = await apiClient.post('/admin/create', payload, config);
    dispatch({ type: CREATE_DISCOUNT_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: CREATE_DISCOUNT_FAIL, payload: error?.response?.data?.errMessage || error.message || error, errors: error?.response?.data });
  }
};

export const listDiscounts = (options = {}) => async (dispatch) => {
  try {
    dispatch({ type: LIST_DISCOUNTS_REQUEST });
    const params = new URLSearchParams();
    if (options.includeArchived === true) params.set('includeArchived', 'true');
    const qs = params.toString();
    const url = `/admin/discounts${qs ? `?${qs}` : ''}`;
    const { data } = await apiClient.get(url);
    dispatch({ type: LIST_DISCOUNTS_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: LIST_DISCOUNTS_FAIL, payload: error?.response?.data?.errMessage || error.message || error });
  }
};

export const getDiscountDetails = (id) => async (dispatch) => {
  try {
    dispatch({ type: DISCOUNT_DETAILS_REQUEST });
    const { data } = await apiClient.get(`/admin/discounts/${id}`);
    dispatch({ type: DISCOUNT_DETAILS_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: DISCOUNT_DETAILS_FAIL, payload: error?.response?.data?.errMessage || error.message || error });
  }
};

export const updateDiscount = (id, payload) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DISCOUNT_REQUEST });
    const config = { headers: { 'Content-Type': 'application/json' } };
    const { data } = await apiClient.put(`/admin/discounts/${id}`, payload, config);
    dispatch({ type: UPDATE_DISCOUNT_SUCCESS, payload: data?.data || data });
  } catch (error) {
    dispatch({ type: UPDATE_DISCOUNT_FAIL, payload: error?.response?.data?.errMessage || error.message || error, errors: error?.response?.data });
  }
};

export const deleteDiscount = (id, options = {}) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_DISCOUNT_REQUEST, meta: { id } });
    await apiClient.delete(`/admin/discounts/${id}`);
    dispatch({ type: DELETE_DISCOUNT_SUCCESS, payload: id });
    // Optionally refresh list
    dispatch(listDiscounts({ includeArchived: !!options.includeArchived }));
  } catch (error) {
    dispatch({ type: DELETE_DISCOUNT_FAIL, payload: error?.response?.data?.errMessage || error.message || error, errors: error?.response?.data, meta: { id } });
  }
};